import { logger } from "@creditas/home-mf-shared";
import { ROOT_LOG_PREFIX } from "./consts";
import { getOriginalPath } from "./root";

export async function logWhenChangeRoute() {
  window.addEventListener(
    "single-spa:routing-event",
    async function routeListener() {
      const pathname = getOriginalPath(location.pathname);

      logger.info({
        message: `[${ROOT_LOG_PREFIX}][CHANGE_ROUTE] Lead route changed to ${pathname}`,
      });
    }
  );
}
